module.exports = __webpack_public_path__ + "static/media/fackbook-logo.cfff9089.png";